import { type TFunction } from 'i18next'
import { JSON_FORM } from '#app/constants/forms.ts'
import {
	ipipNeo120Tree,
	initialQuestionsTree,
} from '#app/features/form/forms/personalityTests/ipipNeo/dynamicTrees.ts'
import { initialValuesIpipNeo } from '#app/features/form/forms/personalityTests/ipipNeo/initialValues.ts'

import { type JSONState } from '#types/form/wizard.ts'

export const initialStateIpipNeo: JSONState<typeof initialValuesIpipNeo> = {
	type: JSON_FORM,
	fieldKey: 'ipipNeoQuestions-empty',
	formId: 'ipipNeo',
	lastSetId: '',
	currentStep: 0,
	allSteps: 1,
	languageId: '',
	formHasBeenCompleted: false,
	includedControllerQuestions: [],
	formState: initialValuesIpipNeo,
	oldFormState: initialValuesIpipNeo,
	currentQuestionId: 'A1',
	currentQuestionTreeId: 'ipipNeoQuestions',
	editableParents: [],
	currentScores: [],
	questionTree: [],
	isInJsonTree: false,
	answeredQuestionsStack: [
		{
			id: 'ipipNeoQuestions',
			answers: [],
			previousAnswers: [],
			currentQuestionId: 'A1',
		},
		{
			id: 'initialQuestions',
			answers: [],
			previousAnswers: [],
			currentQuestionId: 'A1',
		},
	],
	wizardMessages: [],
}

export const initialIpipNeoTree = (t: TFunction) => {
	return [
		{
			id: 'ipipNeoQuestions',
			tree: ipipNeo120Tree(t),
		},
		{
			id: 'initialQuestions',
			tree: initialQuestionsTree(t),
		},
	]
}
